<template>
    <div>
        <main class="main-content">
            <div class="page-content">
            <div class="container">
                <div class="page-links"><router-link to="/settings/exchange" class="page-links__item is-active">Exchange Rate</router-link><router-link to="/settings/smtp" class="page-links__item">SMTP</router-link></div>
                <div class="lds-ring" v-if="!isLoad"><div></div><div></div><div></div><div></div></div>
                <section class="exchange-rate" v-if="isLoad">
                <div class="page-title">
                    <h2>Setting & Data | General | Exchange Rate</h2>
                </div>
                <div class="section-title">
                    <h3>Exchange rate</h3><a href="javascript:void(0)" @click="isOpenSeasons = true" class="btn btn--green">
                    <svg width="1em" height="1em" class="icon icon-list ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-list"></use>
                    </svg><span>Seasons</span></a>
                </div>
                <div class="exchange-rate-inner">
                    <form action="javascript:void(0)" class="exchange-rate-season">
                    <div class="exchange-rate-season__header">
                        <div class="form-control-group"><span class="form-control-label">Choose Season</span>
                        <div :class="['select-wrapper', 'select-wrapper--xl', { 'is-active' : selects.season }]" :style="{opacity: seasons.length ? 1 : .6, cursor: seasons.length ? 'pointer' : 'default', pointerEvents: seasons.length ? 'auto' : 'none'}" @click="selects.season = !selects.season; closeCurrencySelects()">
                            <div class="select-trigger"><span class="select-trigger__name"><b>{{seasons.find(item => item.active) ? seasons.find(item => item.active).name : 'Choose'}}</b> <i>{{seasons.find(item => item.active) ? seasons.find(item => item.active).dateFrom : ''}} {{seasons.find(item => item.active) ? '-' : ''}} {{seasons.find(item => item.active) ? seasons.find(item => item.active).dateTo : ''}}</i></span><span class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                            <div class="select-body">
                            <div class="select-inner">
                                <div 
                                    v-for="item in seasons" 
                                    :key="item.id" 
                                    :class="['select-option', {'is-selected' : item.id === seasons.find(item => item.active).id}]"
                                    @click="seasons = seasons.map(season => item.id === season.id ? {...season, active: true} : {...season, active: false})"
                                    ><span class="select-option__name"><b>{{item.name}}</b> <i>{{item.dateFrom}} - {{item.dateTo}}</i></span></div>
                            </div>
                            </div>
                        </div>
                        <!-- <span title="Sorry, this season is not available because something is wrong" class="form-control-group__error">Sorry, this season is not available because something is wrong</span> -->
                        </div>
                        <button type="button" :style="{opacity: seasons.length ? 1 : .6, cursor: seasons.length ? 'pointer' : 'default', pointerEvents: seasons.length ? 'auto' : 'none'}" data-popover="Copy rates from another season" class="btn btn--green btn--sm-squared btn--popover" @click="copy = true">
                            <svg width="1em" height="1em" class="icon icon-copy ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                            </svg>
                        </button>
                    </div>
                    <div class="exchange-rate-season__inner">
                        <div class="exchange-rate-season__row" 
                            v-for="(item, index) in currency" 
                            :key="index"
                        >
                            <div :class="['form-control-group form-control-group--double']">
                                <div :class="['select-wrapper', 'select-wrapper--xs', { 'is-active' : item.from, 'is-error' : item.fromError}]"  @click="item.fromError = false; toggleCurrencySelect(index, 'from')">
                                <div class="select-trigger"><input
                                    v-model.trim="item.currencyFromSearch"
                                    type="text"
                                    class="select-trigger__name select-trigger__name--input"
                                    aria-label="Search source currency"
                                    autocomplete="off"
                                    spellcheck="false"
                                    @click.stop="openCurrencySearch(index, 'from')"
                                /><span class="select-trigger__icon" @click="item.fromSelectInput = false">
                                    <svg width="1em" height="1em" class="icon icon-chevron ">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                    </svg></span></div>
                                <div class="select-body">
                                  <div class="select-inner">
                                    <div v-for="currency in filteredCurrencies(item.fromSelectInput ? item.currencyFromSearch : '')"
                                         :key="currency"
                                         :class="['select-option', {'is-selected' : item.currencyFrom === currency}]"
                                         @click="selectCurrency(item, 'from', currency); isEdit = true"
                                    >
                                      <span class="select-option__name">{{currency}}</span>
                                    </div>
                                  </div>
                                </div>
                                </div>
                                <div class="form-control-wrap exchange-rate-season__amount">
                                <input type="number" Placeholder="0" @input="item.amountFrom = $event.target.value.replace(/\D/g, '');isEdit = true" @focus="$event.target.parentElement.classList.remove('is-error')" v-model="item.amountFrom" class="form-control"/>
                                </div>
                            </div><span class="form-control-group__equal">=</span>
                            <div :class="['form-control-group form-control-group--double']">
                                <div :class="['select-wrapper', 'select-wrapper--xs', { 'is-active' : item.to, 'is-error' : item.toError }]" @click="item.toError = false; toggleCurrencySelect(index, 'to')">
                                <div class="select-trigger"><input
                                    v-model.trim="item.currencyToSearch"
                                    type="text"
                                    class="select-trigger__name select-trigger__name--input"
                                    aria-label="Search target currency"
                                    autocomplete="off"
                                    spellcheck="false"
                                    @click.stop="openCurrencySearch(index, 'to')"
                                /><span class="select-trigger__icon" @click="item.toSelectInput = false">
                                    <svg width="1em" height="1em" class="icon icon-chevron ">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                    </svg></span></div>
                                <div class="select-body">
                                  <div class="select-inner">
                                    <div v-for="currency in filteredCurrencies(item.toSelectInput ? item.currencyToSearch : '')"
                                         :key="currency"
                                         :class="['select-option', {'is-selected' : item.currencyTo === currency}]"
                                         @click="selectCurrency(item, 'to', currency); isEdit = true"
                                    >
                                      <span class="select-option__name">{{currency}}</span>
                                    </div>
                                  </div>
                                </div>
                                </div>
                                <div class="form-control-wrap exchange-rate-season__amount">
                                <input type="number" Placeholder="0" @input="item.amountTo = $event.target.value.replace(/\D/g, '');isEdit = true" @focus="$event.target.parentElement.classList.remove('is-error')" v-model="item.amountTo" class="form-control"/>
                                </div>
                            </div>
                            <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
                                    entity: 'Rate',
                                    name: 'this',
                                    handler: removeCurrencyHandler,
                                    id: index
                                })">
                                <svg width="1em" height="1em" class="icon icon-close ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                </svg>
                            </button>
                        </div>
                        <div class="exchange-rate-season__row">
                        <button type="button" class="btn btn--rounded" :disabled="!seasons.length" @click="addCurrencyHandler"><span>Add Currency</span></button>
                        <button type="button" class="btn btn--green btn--sm" @click="saveCurrencyHandler"><span>Save</span></button>
                        </div>
                    </div>
                    </form>
                </div>
                </section>
            </div>
            </div>
        </main>
        <Seasons @notLeavePopupHandler="data => $emit('notLeavePopupHandler', data)" @errored="$emit('errored')" @deleteModalHandler="data => $emit('deleteModalHandler', data)" :open="isOpenSeasons" @confirmed="$emit('confirmed')" :title="'Exchange Rate'" @close="closeSeasons" :type="'exchange'" :user="user"/>
        <div class="modal-wrapper" v-if="copy">
            <div class="modal-backdrop"></div>
            <div class="modal-inner">
                <div class="edit-popup edit-popup--copy-season">
                    <div class="edit-popup__header">
                        <div class="edit-popup__title">
                        <div class="edit-popup__title__icon">
                            <svg width="1em" height="1em" class="icon icon-copy ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                            </svg>
                        </div><span>Copy rates </span>
                        </div>
                        <div class="edit-popup__close" @click="copy = false">
                        <svg width="1em" height="1em" class="icon icon-close ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                        </svg>
                        </div>
                    </div>
                    <form action="javascript:void(0)" class="edit-popup__inner">
                        <div class="edit-popup__info" v-if="seasons.find(item => item.active)">
                        <p>{{seasons.find(item => item.active).name}} <i>{{seasons.find(item => item.active).dateFrom}} - {{seasons.find(item => item.active).dateTo}}</i></p>
                        </div>
                        <div class="edit-popup__side-wrap">
                        <div class="edit-popup__side" v-if="copySeasons.find(item => item.active)">
                            <div class="form-control-group"><span class="form-control-label form-control-label-bold">Prices for the <b>"{{seasons.find(item => item.active).name}}"</b> season will be copied from the season:</span>
                            <div :class="['select-wrapper', 'select-wrapper--xl', { 'is-active' : selects.seasonCopy }]" @click="selects.seasonCopy = !selects.seasonCopy; closeCurrencySelects()">
                                <div class="select-trigger"><span class="select-trigger__name"><b>{{copySeasons.find(item => item.active).name}}</b> <i>{{copySeasons.find(item => item.active).dateFrom}} - {{copySeasons.find(item => item.active).dateTo}}</i></span><span class="select-trigger__icon">
                                    <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                    </svg></span></div>
                                <div class="select-body">
                                <div class="select-inner">
                                    <div 
                                        v-for="item in copySeasons" 
                                        :key="item.id" 
                                        :class="['select-option', {'is-selected' : item.id === copySeasons.find(item => item.active).id}]"
                                        @click="copySeasons = copySeasons.map(season => item.id === season.id ? {...season, active: true} : {...season, active: false})"
                                        ><span class="select-option__name"><b>{{item.name}}</b> <i>{{item.dateFrom}} - {{item.dateTo}}</i></span></div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        <button type="submit" class="btn btn--green edit-popup__submit" @click="copySeasonsHandler">
                            <svg width="1em" height="1em" class="icon icon-copy ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                            </svg><span>Copy</span>
                        </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { getSeasonsAll, getCurrency, addCurrency, copyExchangeSeasons } from '@/utilites/api'
    import { CURRENCIES } from '@/common/helpers/currency'

    import Seasons from '@/components/Seasons'
    import ClipboardJS from 'clipboard'
    export default {
        props: ['user'],
        components: { Seasons, ClipboardJS },
        data(){
            return {
                seasons: [],
                currency: [],
                selects: {
                    season: false,
                    seasonCopy: false
                },
                selectsActive: {
                    season: '',
                },
                isOpenSeasons: false,
                copy: false,
                copySeasons: [],
                isLoad: false,
                isEdit: false,
                CURRENCIES
            }
        },
        beforeRouteLeave(to, from, next){
			if(this.isEdit){
				this.$emit('notLeaveHandler')
			}
			next()
		},
        beforeCreate(){
            document.title = 'Setting & Data / General / Exchange Rate'
        },
        mounted(){
            document.title = 'Setting & Data / General / Exchange Rate'
            this.updateData()
            window.addEventListener('click', event => {
                if(!event.target.closest('.select-wrapper')){
                    this.selects = {
                        season: false,
                        seasonCopy: false
                    }
                    this.closeCurrencySelects()
                }
                if(!event.target.closest('.edit-popup') && !event.target.closest('.btn')){
                    this.copy = false
                }
            })
        },
        methods: {
            prepareCurrency(item){
                return {
                    ...item,
                    from: false,
                    to: false,
                    fromSelectInput: false,
                    toSelectInput: false,
                    currencyFromSearch: item.currencyFrom || '',
                    currencyToSearch: item.currencyTo || ''
                }
            },
            closeCurrencySelects(){
                this.currency = this.currency.map(item => ({
                    ...item,
                    from: false,
                    to: false,
                    fromSelectInput: false,
                    toSelectInput: false,
                    currencyFromSearch: item.currencyFrom,
                    currencyToSearch: item.currencyTo
                }))
            },
            toggleCurrencySelect(index, type){
                const isFrom = type === 'from'
                this.currency = this.currency.map((item, itemIndex) => ({
                    ...item,
                    from: isFrom && itemIndex === index ? !item.from : false,
                    to: !isFrom && itemIndex === index ? !item.to : false,
                    fromSelectInput: false,
                    toSelectInput: false,
                    currencyFromSearch: item.currencyFrom,
                    currencyToSearch: item.currencyTo
                }))
            },
            openCurrencySearch(index, type){
                const isFrom = type === 'from'
                this.currency = this.currency.map((item, itemIndex) => ({
                    ...item,
                    from: isFrom && itemIndex === index,
                    to: !isFrom && itemIndex === index,
                    fromSelectInput: isFrom && itemIndex === index,
                    toSelectInput: !isFrom && itemIndex === index,
                    currencyFromSearch: itemIndex === index && isFrom
                        ? item.currencyFromSearch
                        : item.currencyFrom,
                    currencyToSearch: itemIndex === index && !isFrom
                        ? item.currencyToSearch
                        : item.currencyTo
                }))
            },
            selectCurrency(item, type, currency){
                if(type === 'from'){
                    item.currencyFrom = currency
                    item.currencyFromSearch = currency
                    item.fromSelectInput = false
                } else {
                    item.currencyTo = currency
                    item.currencyToSearch = currency
                    item.toSelectInput = false
                }
            },
            filteredCurrencies(search){
                const normalizedSearch = (search || '').toLowerCase()
                return this.CURRENCIES.filter(currency => currency.toLowerCase().includes(normalizedSearch))
            },
            checkErrors(){
                let error = false
                document.querySelectorAll('input[type="number"]').forEach(elem => {
                    if(+elem.value === 0){
                        elem.parentElement.classList.add('is-error')
                        error = true
                    }
                })
                this.currency = this.currency.map(item => item.currencyFrom === item.currencyTo ? ({...item, fromError: true, toError: true }) : ({...item, fromError : false, toError: false}))
                return error || this.currency.find(item => item.fromError || item.toError)
            },
            saveCurrencyHandler(){
                if(!this.checkErrors()){
                    addCurrency(this.user.access_token, this.seasons.find(item => item.active).id, this.currency.map(item => {
                        let obj = {
                            currencyFrom : item.currencyFrom,
                            currencyTo : item.currencyTo,
                            amountFrom : +item.amountFrom,
                            amountTo : +item.amountTo,
                        }
                        if(item.id){
                            obj.id = item.id
                        }
                        return obj
                    }))
                    .then(() => {
                        this.$emit('confirmed')
                        this.isEdit = false
                    })
                }
            },
            addCurrencyHandler(){
                this.currency = this.currency.concat(this.prepareCurrency({
                    currencyFrom : 'USD',
                    currencyTo : 'EUR',
                    amountFrom : '',
                    amountTo : ''
                }))
                this.isEdit = true
            },
            copySeasonsHandler() {
                copyExchangeSeasons(this.user.access_token, this.copySeasons.find(item => item.active).id, this.seasons.find(item => item.active).id)
                .then(res => {
                    this.currency = res.map(this.prepareCurrency)
                    this.copy = false
                    this.isEdit = true
                })
                .catch(() => this.copy = false)
            },
            removeCurrencyHandler(id){
                this.currency = this.currency.filter((item, index) => !(index === id))
                this.isEdit = true
            },
            closeSeasons(){
                this.isOpenSeasons = false
            },
            updateData(){
                this.isLoad = false
                getSeasonsAll(this.user.access_token)
                .then(res => {
                    this.isLoad = true
                    this.seasons = res.map((item, index) => index === 0 ? {...item, active: true} : {...item, active: false})
                    this.copySeasons = res.map((item, index) => index === 0 ? {...item, active: true} : {...item, active: false})
                })
            }
        },
        watch:{
            isOpenSeasons(){
                if(!this.isOpenSeasons){
                    this.updateData()
                }
            },
            seasons(){
                this.isLoad = false
                if(this.seasons.find(item => item.active)){
                    getCurrency(this.user.access_token, this.seasons.find(item => item.active).id)
                    .then(response => {
                        this.isLoad = true
                        this.currency = response.map(this.prepareCurrency)
                    })
                } else {
                    this.isLoad = true
                }
            },
        }
    }
</script>

<style scoped>
@media (min-width: 431px) {
    .exchange-rate-season__amount {
        width: 9rem;
    }
}
</style>
